import { OverrideStatusEnum } from 'src/common/external/bambi-api/bambiApi';
import { Badge } from 'src/common/primitives/Badge';

export const TripStatusBadge = (status: OverrideStatusEnum | undefined) => {
  let color = '';

  switch (status) {
    case 'canceled':
    case 'rejected':
      color = 'red';
      break;
    case 'transporting':
      color = 'yellow';
      break;
    case 'pending':
      color = 'orange';
      break;
    case 'completed':
      color = 'green';
      break;
    case 'en route':
    default:
      color = 'primary';
  }

  return Badge({
    label: status || 'unknown',
    color,
  });
};
